/**
 * Constants
 * @object
 */

const config = {};

const actions = {
  SHOOT_BALL: 'SHOOT_BALL',
  SET_LEVEL: 'SET_LEVEL',
  RESET: 'RESET',
  PAUSE: 'PAUSE',
  UN_PAUSE: 'UN_PAUSE',
  MAIN_ASSETS_LOADED: 'MAIN_ASSETS_LOADED',
  INSTRUCTIONS_VIEWED: 'INSTRUCTIONS_VIEWED',
};

const constants = Object.assign(config, actions);

export default constants;



/** WEBPACK FOOTER **
 ** ./assets/js/src/constants/AppConstants.js
 **/